<template>

    <div class="my-5">

        <div class="nestable-draggable-parent-wrapper">

            <nested-draggable :nests="nests"></nested-draggable>

        </div>

        <hr>

        <textarea name="categories_nestable" id="categories_nestable_hidden" :value="processedCategoryTree" hidden class="d-none"></textarea>

    </div>

</template>
<script>
  import draggable from 'vuedraggable';

  export default {

    props: {
      categories: {
        required: false
      }
    },

    computed: {
      processedCategoryTree() {
        return JSON.stringify( this.nests );
      }
    },

    data() {
      return {
        nests: this.categories,
      };
    },

    components: {
      draggable
    },
  };
</script>

<style scoped>

    .nestable-draggable-parent-wrapper .dragArea {

        min-height: 0;
        margin: 0;
        background: transparent;
        border: none;
        padding: 0;
        border-radius: 0;
        position: relative;

    }

    .nestable-draggable-parent-wrapper .dragArea:hover {
        padding: 0;
    }

</style>